<ng-container *ngIf="showing">
  <div class="flash-messages">
    <div *ngFor="let message of messages" class="flash-message alert alert-{{ type }}">
      <div>
        <div [innerHTML]="message | translate"></div>
      </div>
      <button type="button" class="close" (click)="closeClicked(message)"><span translate>app.message.close</span></button>
    </div>
  </div>
</ng-container>